<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const PopularTabIcon = getIcon("PopularTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = void 0;
</script>

{#if typeof PopularTabIcon === 'string'}
	<img src={PopularTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof PopularTabIcon === 'function'}
	<svelte:component this={PopularTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
